import * as mutations from "./mutations"
import * as queries from "./queries"
const gql = { queries, mutations }
export default gql
